import { styled } from "goober";
import { useState } from "react";
import { SettingsCard, SettingsHeading, SettingsRow } from "../SettingsCard";
import { Text } from "../Text";
import { DisclosureToggle } from "./DisclosureToggle";

const Collapse = styled("div")`
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition:
    grid-template-rows var(--motion-base) var(--ease-out),
    opacity var(--motion-base) var(--ease-out);
  &[data-open] {
    grid-template-rows: 1fr;
    opacity: 1;
  }
`;

// Bleeds sideways so the clip doesn’t cut off input focus rings.
const Clip = styled("div")`
  min-height: 0;
  overflow: hidden;
  margin: 0 -4px;
  padding: 0 4px;
`;

const Fields = styled("div")`
  padding: 16px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export function AdvancedSection({
  defaultOpen,
  summary,
  children,
}: {
  defaultOpen: boolean;
  summary: string;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <SettingsCard style={{ gap: 0 }}>
      <SettingsRow>
        <SettingsHeading>
          <Text variant="text-regular-md">Advanced</Text>
          {!open && (
            <Text variant="text-small" color="var(--text-secondary)">
              {summary}
            </Text>
          )}
        </SettingsHeading>
        <DisclosureToggle
          size="l"
          variant="secondary"
          icon="chevron-down"
          aria-label={
            open ? "Hide advanced settings" : "Show advanced settings"
          }
          aria-expanded={open}
          onPress={() => setOpen((was) => !was)}
        />
      </SettingsRow>
      <Collapse data-open={open || undefined} inert={!open}>
        <Clip>
          <Fields>{children}</Fields>
        </Clip>
      </Collapse>
    </SettingsCard>
  );
}
